import { Stack, Paper, Typography, TextField, Button, IconButton, Divider, Tooltip } from "@mui/material";
import { FieldArray } from "formik";
import { HugeiconsIcon } from "@hugeicons/react";
import { FavouriteIcon, Delete02Icon, Add01Icon } from "@hugeicons/core-free-icons";
import { useResponsive } from "@/hooks";
// import NeighborhoodAutocomplete from "@/components/NeighborhoodAutocomplete";

interface Props {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  isLoading?: boolean;
  onClose: () => void;
  onUpdateClient?: (values: any) => Promise<void>;
}

const EditCustomerTab = ({ values, setFieldValue, onUpdateClient, isLoading, onClose }: Props) => {
  const { isMobile } = useResponsive();
  const direction = isMobile ? "column" : "row";

  const validateSingleDefault = () => {
    const defaults = values.locations?.filter((loc: any) => loc.isDefault);
    return defaults.length <= 1;
  };

  const handleUpdate = async () => {
    if (!validateSingleDefault()) {
      return;
    }
    await onUpdateClient?.(values);
    onClose();
  };

  const markAsDefault = (index: number) => {
    const updated = values.locations.map((loc: any, i: number) => ({
      ...loc,
      isDefault: i === index,
    }));
    setFieldValue("client.locations", updated);
  };

  return (
    <Stack spacing={3}>
      <Stack direction={direction} spacing={2}>
        <Paper sx={{ p: 2, flex: 1 }}>
          <Typography variant="h4" mb={2}>
            Cliente
          </Typography>
          <Stack spacing={2}>
            <TextField label="Nombre" value={values?.name ?? ""} onChange={(e) => setFieldValue("client.name", e.target.value)} fullWidth size="small" disabled />

            <TextField label="Apellido" value={values?.lastname ?? ""} onChange={(e) => setFieldValue("client.lastname", e.target.value)} fullWidth size="small" disabled />
          </Stack>
        </Paper>

        <Paper sx={{ p: 2, flex: 1 }}>
          <Typography variant="h4" mb={2}>
            Contacto
          </Typography>
          <Stack spacing={2}>
            <TextField label="Whatsapp" value={values?.phone ?? ""} onChange={(e) => setFieldValue("client.phone", e.target.value)} fullWidth size="small" disabled />

            <TextField label="Correo" value={values?.email ?? ""} onChange={(e) => setFieldValue("client.email", e.target.value)} fullWidth size="small" disabled />
          </Stack>
        </Paper>
      </Stack>

      <Paper sx={{ p: 2 }}>
        <Typography variant="h4" mb={2}>
          Direcciones
        </Typography>

        <FieldArray
          name="client.locations"
          render={(arrayHelpers) => (
            <Stack spacing={3}>
              {values.locations?.map((loc: any, index: number) => (
                <Stack spacing={2} key={index}>
                  <Stack spacing={2} direction={isMobile ? "column" : "row"}>
                    <TextField label="Nombre" value={loc.type ?? ""} onChange={(e) => setFieldValue(`client.locations.${index}.type`, e.target.value)} fullWidth size="small" />
                    {/* <NeighborhoodAutocomplete
                      fullWidth
                      size="small"
                      value={loc.neighborhood ?? ""}
                      onChange={(value) => {
                        setFieldValue(`client.locations.${index}.neighborhood`, value);
                      }}
                    /> */}
                    <TextField label="Casa" value={loc.house ?? ""} onChange={(e) => setFieldValue(`client.locations.${index}.house`, e.target.value)} size="small" />
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Tooltip title="Seleccionar esta dirección" placement="top" arrow>
                        <IconButton onClick={() => markAsDefault(index)}>
                          <HugeiconsIcon icon={FavouriteIcon} size={22} color={loc.isDefault ? "red" : "#9ca3af"} />
                        </IconButton>
                      </Tooltip>

                      {values.locations.length > 1 && (
                        <Tooltip title="Eliminar esta dirección" placement="top" arrow>
                          <IconButton onClick={() => arrayHelpers.remove(index)}>
                            <HugeiconsIcon icon={Delete02Icon} size={22} color="#9ca3af" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Stack>
                  </Stack>

                  <TextField
                    label="Dirección"
                    value={loc.address ?? ""}
                    onChange={(e) => setFieldValue(`client.locations.${index}.address`, e.target.value)}
                    fullWidth
                    size="small"
                  />
                  {values.locations.length - 1 !== index ? <Divider /> : null}
                </Stack>
              ))}
              <Stack alignItems={"center"}>
                <Button
                  endIcon={<HugeiconsIcon icon={Add01Icon} />}
                  onClick={() =>
                    arrayHelpers.push({
                      type: "",
                      // neighborhood: "",
                      house: "",
                      address: "",
                      latitude: "",
                      longitude: "",
                      isDefault: false,
                    })
                  }
                >
                  Agregar
                </Button>
              </Stack>
            </Stack>
          )}
        />
      </Paper>

      <Stack direction={"row"} spacing={2}>
        <Button disabled={isLoading} onClick={handleUpdate} color={"success"}>
          Guardar
        </Button>
        <Button variant="text" disabled={isLoading} onClick={onClose}>
          Cancelar
        </Button>
      </Stack>
    </Stack>
  );
};

export default EditCustomerTab;
